import { BarChart } from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";

const NoChartDataEmptyState = () => {
  return (
    <Box
      width="100%"
      height={300}
      minHeight={300}
      border="1px solid lightgrey"
      borderRadius={2}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Stack direction="column" alignItems="center" justifyContent="center">
        <BarChart />
        <Typography fontWeight="bold" fontSize="14px">
          Non ci sono dati per le misure selezionate
        </Typography>
      </Stack>
    </Box>
  );
};

export default NoChartDataEmptyState;
